import { TrendingDown, BadgeCheck, Zap, Users, CheckCircle, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { mockData } from '../utils/mock';

const iconMap = {
  TrendingDown,
  BadgeCheck,
  Zap,
  Users,
  CheckCircle,
  TrendingUp
};

export const Benefits = () => {
  const { benefits } = mockData;

  return (
    <section id="benefits" className="py-20 bg-gray-50" aria-labelledby="benefits-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 id="benefits-heading" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our TOR1 Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Save thousands on duty and VAT when relocating your belongings back to the UK
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => {
            const Icon = iconMap[benefit.icon];
            return (
              <Card 
                key={benefit.id} 
                className="border-none shadow-md hover:shadow-xl transition-all duration-300 bg-white group"
              >
                <CardHeader>
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-900 transition-colors">
                    <Icon className="text-blue-900 group-hover:text-white transition-colors" size={24} />
                  </div>
                  <CardTitle className="text-lg">{benefit.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
